import React from 'react';

const I18nContext = /*#__PURE__*/React.createContext(null);
const I18nIdsContext = /*#__PURE__*/React.createContext([]);
const I18nParentContext = /*#__PURE__*/React.createContext(null);

export { I18nContext, I18nIdsContext, I18nParentContext };
